import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from '../../../settings/local_settings';
import {LayoutSidebar} from "../../../Layout";
import {Spinner} from "../../Spinner";
import {BusinessUnitGlobalInfoForm} from "./BusinessUnitGlobalInfoForm";
import {BusinessUnitTabs} from "../BusinessUnitTabs";
import {BusinessUnitHeader} from "../BusinessUnitHeader";
import {InfoNotification} from "../../notifications/InfoNotification";
import {AdAccountsActionDataHandler} from "../../AdAccountsActionDataHandler";
import {Alert} from "reactstrap";
import {TYPE_ONE_BUDGET_PER_ADGROUP, TYPE_ONE_BUDGET_PER_CAMPAIGN} from "../BusinessUnitTypes";
import {ItemScheduleConfiguration} from "../../../utils/ItemScheduleConfiguration";
import {withRouterParams} from "../../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class EditBusinessUnitPage extends Component {
    constructor(props) {
        super(props);
        this.handleGoToTabUrl = this.handleGoToTabUrl.bind(this);
    }

    handleGoToTabUrl(url) {
        this.props.history.push(url);
    }

    submitUrl() {
        return API_URL + `business-unit/${this.props.match.params.id}/edit`;
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <EditBusinessUnitPageContent businessUnitId={this.props.match.params.id}
                                             submitUrl={this.submitUrl()}
                                             goToTabUrl={this.handleGoToTabUrl}
                />
            </div>
        )
    }
}

export default withRouterParams(EditBusinessUnitPage);

class EditBusinessUnitPageContentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            businessUnitGeneralData: null,
            hasChanges:false
        };
        this.handleGlobalInfoEdited = this.handleGlobalInfoEdited.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleGoToTabUrl = this.handleGoToTabUrl.bind(this);
    }


    handleGoToTabUrl(url) {
        this.props.goToTabUrl(url);
    }

    handleChange() {
        this.setState({hasChanges:true});
    }

    componentDidMount() {
        this.getBusinessUnitData();
    }

    editBusinessUnitUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/edit`;
    }

    getBusinessUnitData() {
        new APIClient(this.editBusinessUnitUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    businessUnitGeneralData: {
                        name: response.data.name,
                        budgetType: response.data.budget_type,
                        businessUnitType: response.data.business_unit_type,
                        totalBudget: response.data.total_budget,
                        rollover: response.data.rollover,
                        canEditCurrency: response.data.can_edit_currency,
                        budgetCurrency: response.data.budget_currency,
                        budgetPartialGoals: response.data.budget_partial_goals,
                        budgetPartialGoalsInputDefinition: response.data.budget_partial_goals_input_definition,
                        allocatedBudget: response.data.allocated_budget,
                        leftoverBudget: response.data.leftover_budget,
                        status: response.data.status,
                        clientId: response.data.client_id,
                        clientName: response.data.client_name,
                        campaignChannel: response.data.campaign_channel,
                        campaignChannelForDisplay: response.data.campaign_channel_for_display,
                        periodType: response.data.period_type_enum,
                        periodFirstDate: response.data.period_first_date_yyyymmdd,
                        periodLastDate: response.data.period_last_date_yyyymmdd,
                        firstDay: response.data.first_day,
                        accountsQuantity: response.data.accounts_quantity,
                        linkedAccountCurrencies: response.data.linked_account_currencies,
                        goal1: response.data.goal_1,
                        goal2: response.data.goal_2,
                        adAccountsActionData: response.data.business_unit_ad_accounts_actions_data,
                        itemScheduleConfiguration: new ItemScheduleConfiguration(response.data.schedule_configuration_data)
                    }
                });
            }
        })
    }

    handleGlobalInfoEdited(data) {
        const previousData = this.state.businessUnitGeneralData;
        this.setState({
            ...this.state,
            hasChanges:false,
            businessUnitGeneralData: {
                ...previousData,
                ...data
            }
        })
    }

    render() {
        const { t } = this.props;
        if (this.state.businessUnitGeneralData !== null) {
            return (
                <section className="section-content">
                    <InfoNotification/>
                    <BusinessUnitHeader businessUnitId={this.props.businessUnitId}
                                        name={this.state.businessUnitGeneralData.name}
                                        status={this.state.businessUnitGeneralData.status}
                                        clientId={this.state.businessUnitGeneralData.clientId}
                                        clientName={this.state.businessUnitGeneralData.clientName}
                                        campaignChannel={this.state.businessUnitGeneralData.campaignChannel}
                                        campaignChannelForDisplay={this.state.businessUnitGeneralData.campaignChannelForDisplay}
                    />
                    <BusinessUnitTabs
                        businessUnitId={this.props.businessUnitId}
                        activeTab="-first"
                        changesMade={this.state.hasChanges}
                        goToTabUrl={this.handleGoToTabUrl}
                    />
                    {this.renderImportantMessages()}
                    <div className="section-body h-items">
                        <div className="section-body-item -wide box">
                            <header className="box-header">
                                <h2 className="box-title">{t('business_unit_global_info.title')}</h2>
                            </header>
                            <BusinessUnitGlobalInfoForm
                                itemScheduleConfiguration={this.state.businessUnitGeneralData.itemScheduleConfiguration}
                                isSaving={this.state.saving}
                                onChange={this.handleChange}
                                businessUnitId={this.props.businessUnitId}
                                name={this.state.businessUnitGeneralData.name}
                                totalBudget={this.state.businessUnitGeneralData.totalBudget}
                                canEditCurrency={this.state.businessUnitGeneralData.canEditCurrency}
                                budgetCurrency={this.state.businessUnitGeneralData.budgetCurrency}
                                allocatedBudget={this.state.businessUnitGeneralData.allocatedBudget}
                                budgetPartialGoals={this.state.businessUnitGeneralData.budgetPartialGoals}
                                budgetPartialGoalsInputDefinition={this.state.businessUnitGeneralData.budgetPartialGoalsInputDefinition}
                                rollover={this.state.businessUnitGeneralData.rollover}
                                leftoverBudget={this.state.businessUnitGeneralData.leftoverBudget}
                                submitUrl={this.props.submitUrl}
                                budgetType={this.state.businessUnitGeneralData.budgetType}
                                periodType={this.state.businessUnitGeneralData.periodType}
                                periodFirstDate={this.state.businessUnitGeneralData.periodFirstDate}
                                periodLastDate={this.state.businessUnitGeneralData.periodLastDate}
                                firstDay={this.state.businessUnitGeneralData.firstDay}
                                accountsQuantity={this.state.businessUnitGeneralData.accountsQuantity}
                                linkedAccountCurrencies={this.state.businessUnitGeneralData.linkedAccountCurrencies}
                                afterGlobalInfoEdited={this.handleGlobalInfoEdited}
                                goal1={this.getGoalData(1, this.state.businessUnitGeneralData)}
                                goal2={this.getGoalData(2, this.state.businessUnitGeneralData)}
                                adAccountsActionData={new AdAccountsActionDataHandler(this.state.businessUnitGeneralData.adAccountsActionData, t)}
                            />
                        </div>
                    </div>
                </section>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderImportantMessages() {
        const { t } = this.props;
        if(this.state.businessUnitGeneralData.accountsQuantity === 0) {
            return <div className="section-body h-items" style={{paddingBottom:'0'}}>
                    <div className="section-body-item -wide">
                        <Alert className="alert-warning filtering-alert">
                            {t('business_unit_global_info.no_campaigns_alert').split('\n\n').map((line, index, array) => (
                                <React.Fragment key={index}>
                                    {line}
                                    {index < array.length - 1 && <><br/><br/></>}
                                </React.Fragment>
                            ))}
                        </Alert>
                    </div>
                </div>;
        } else if(this.state.businessUnitGeneralData.allocatedBudget === 0 && (this.state.businessUnitGeneralData.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN || this.state.businessUnitGeneralData.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP)) {
            const entity = this.state.businessUnitGeneralData.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN ? t('business_unit_global_info.campaign') : t('business_unit_global_info.ad_group');

            return <div className="section-body h-items" style={{paddingBottom:'0'}}>
                    <div className="section-body-item -wide">
                        <Alert className="alert-warning filtering-alert">
                            {t('business_unit_global_info.budget_assignment_alert').replace('{{entity}}', entity).split('\n\n').map((line, index, array) => (
                                <React.Fragment key={index}>
                                    {line}
                                    {index < array.length - 1 && <><br/><br/></>}
                                </React.Fragment>
                            ))}
                        </Alert>
                    </div>
                </div>;
        }
    }

    getGoalData(priority, businessUnitGeneralData) {
        const goal_data = priority === 1 ?  businessUnitGeneralData.goal1 : businessUnitGeneralData.goal2;
        return goal_data !== null ? {
            "metricName": goal_data["metric_name"],
            "value":  goal_data["value"],
            "metricConversionConfiguration": goal_data["metric_conversion_configuration"] !== undefined ? goal_data["metric_conversion_configuration"] : null
        } : null;
    }
}

export const EditBusinessUnitPageContent = withTranslation()(EditBusinessUnitPageContentClass);
